// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"az_SYb","containerRightFrame":"az_TYb","outerContainer":"az_UYb","table":"az_VYb","tableHeadCellSticky":"az_WYb","tableRow":"az_XYb","tableCell":"az_YYb"};